// extracted by mini-css-extract-plugin
export var active = "arrow-overlay-module--active--OTrDI";
export var blackButtons = "arrow-overlay-module--blackButtons--VsyhL";
export var dissection = "arrow-overlay-module--dissection--RSUx1";
export var hover = "arrow-overlay-module--hover--lzu74";
export var next = "arrow-overlay-module--next--LTmxL";
export var orangeButtons = "arrow-overlay-module--orangeButtons--3V3vx";
export var previous = "arrow-overlay-module--previous--yzP5V";
export var slideButton = "arrow-overlay-module--slideButton--su+8r";